import React from "react";
import { RadioGroup as MuiRadioGroup } from "@material-ui/core";
import clsx from "clsx";
import { RadioGroupPropsModel } from "./tools/RadioGroup.model";
import { RadioGroupVariant } from "./tools/RadioGroup.const";

import useStyles from "./RadioGroup.style";

export const RadioGroup = ({
  children,
  onChange,
  required = false,
  ariaRequiredId,
  hasError = false,
  testId = 'RadioGroup',
  variant = RadioGroupVariant.VERTICAL,
  ...props
}: RadioGroupPropsModel) => {
  const classes = useStyles({ variant });

  return (
    <MuiRadioGroup
      data-testid={testId}
      onChange={onChange}
      data-type="ui/RadioGroup"
      {...props}
      {...(required && {
        'aria-required': true,
        ...(hasError && ariaRequiredId && { 'aria-describedby': ariaRequiredId })
      })}
      className={clsx(classes.root, props.className)}
    >
      {children}
    </MuiRadioGroup>
  );
};
